"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RSS = exports.TIP = exports.RGEO = exports.GEO = void 0;
var config_1 = require("../common/config");
var init_1 = require("../common/init");
var interface_utils_1 = require("@uip-alpha/interface-utils");
// 顺丰APIkey
// const SFAK = '14e9ee810854c40f5ae9414f2a62c8cc'
/**
 * GEO新接口
 * @param	参数	类型	必须	描述
 * @param	address	string	是	详细地址
 * @param	orderno	string	否	业务关键字段
 * @param	province	string	否	省信息，中文
 * @param	city	string	否	城市信息，中文
 * @param	county	string	否	区县信息，中文
 * @param	town	string	否	镇(街道)
 * @param	citycode	string	否	城市代码
 * @param	level	string	否	地址级别，默认是返回4级地址，如果传入3，则返回3级地址
 * @param	opt	string	否	默认是空，CX GEO优先返回，CX1 返回地址的经纬度
 * @param	ak	string	是	授权ak
 */
exports.GEO = function (params, config) {
    if (!params || !params.address)
        return Promise.resolve({});
    var defaultParams = {
        opt: 'cx1',
        ak: _this._ak
    };
    return _this.http
        .jsonp(interface_utils_1.assign({
        url: _this._baseUrl + "/segcx/api/split",
        params: __assign(__assign({}, defaultParams), params),
        timeout: 2000
    }, interface_utils_1.assign({
        opts: {
            callbackName: 'cb',
            name: 'cx'
        }
    }, config)))
        .then(function (r) {
        var data = Object(r);
        return (Number(data.status) === 0 && data.result && data.result.data && __assign(__assign({}, data.result.data), { multiple: data.result.multiple, mark: data.result.mark })) || {};
    })
        .catch(function () {
        return {};
    });
};
/**
 * RGEO新接口
 */
exports.RGEO = function (params, config) {
    var defaultParams = {
        cc: '2',
        poinum: 10,
        ak: _this._ak
    };
    return _this.http
        .jsonp(interface_utils_1.assign({
        url: _this._baseUrl + "/rgeo/api",
        params: __assign(__assign({}, defaultParams), params),
        timeout: 2000
    }, interface_utils_1.assign({
        opts: {
            callbackName: 'cb',
            name: 'cx'
        }
    }, config)))
        .then(function (r) {
        var data = Object(r);
        return data.result || {};
    })
        .catch(function () {
        return {};
    });
};
/**
 * TIP新接口
 */
exports.TIP = function (params, config) {
    var defaultParams = {
        cc: '2',
        poinum: 10,
        ak: _this._ak
    };
    return _this.http
        .jsonp(interface_utils_1.assign({
        url: _this._baseUrl + "/tip/api",
        params: __assign(__assign({}, defaultParams), params),
        timeout: 2000
    }, interface_utils_1.assign({
        opts: {
            callbackName: 'cb',
            name: 'cx'
        }
    }, config)))
        .then(function (r) {
        var data = Object(r);
        return data.result || {};
    })
        .catch(function () {
        return {};
    });
};
/**
 * GIS路径规划接口
 */
exports.RSS = function (params, config) {
    var defaultParams = {
        cc: 1,
        opt: 'sf2',
        ak: _this._ak
    };
    return _this.http
        .jsonp(interface_utils_1.assign({
        url: "" + config_1.rssHost[_this.http._env],
        params: __assign(__assign({}, defaultParams), params),
        timeout: 20000
    }, interface_utils_1.assign({
        opts: {
            name: 'cb'
        }
    }, config)))
        .then(function (r) {
        var data = Object(r);
        return (+data.status === 0 && data.result) || {};
    })
        .catch(function () {
        return {};
    });
};
/**
 * 此config主要为设置mode和header参数，以及具体业务参数转化
 * 此模块须config传入ak才可使用,如果不传，则需要在
 */
exports.default = (function (config) { return function (UIP) {
    /** 前置依赖模块检测 */
    if (!interface_utils_1.beforeInit(UIP)('http'))
        return;
    if (!config || !config.ak) {
        console.error('此模块需要传入授权ak参数配置才可使用');
    }
    _this._ak = config.ak || '';
    /** 删除ak，防止默认添加header中 */
    delete config.ak;
    _this.http = init_1.init(config)(UIP);
    _this._baseUrl = config_1.gisHost[_this.http._env];
    UIP.checkModule('interface', 'geo', 'gis');
    UIP.interface.geo.gis = {
        GEO: exports.GEO.bind(_this),
        RGEO: exports.RGEO.bind(_this),
        TIP: exports.TIP.bind(_this),
        RSS: exports.RSS.bind(_this)
    };
}; });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-geo/dist/gis/index.js
// module id = 6F8D
// module chunks = 1